/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type CreateQuestionnaireWithQuestionsMutationVariables = Types.Exact<{
  object: Types.CreateQuestionnaireWithQuestionsInput;
}>;

export type CreateQuestionnaireWithQuestionsMutation = {
  __typename?: 'mutation_root';
  create_questionnaire_with_questions: string;
};

export const CreateQuestionnaireWithQuestionsDocument = `
    mutation CreateQuestionnaireWithQuestions($object: CreateQuestionnaireWithQuestionsInput!) {
  create_questionnaire_with_questions(object: $object)
}
    ` as string &
  TypedDocumentNode<
    CreateQuestionnaireWithQuestionsMutation,
    CreateQuestionnaireWithQuestionsMutationVariables
  >;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    CreateQuestionnaireWithQuestions: build.mutation<
      CreateQuestionnaireWithQuestionsMutation,
      CreateQuestionnaireWithQuestionsMutationVariables
    >({
      query: (variables) => ({ document: CreateQuestionnaireWithQuestionsDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateQuestionnaireWithQuestionsMutation } = injectedRtkApi;
